import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { updateOnboarding } from "../api";
import { redirectUser } from "../helpers";
import { LoginStore } from "../store/login";
import { AvatarUpload } from "src/components";

import { Logo } from "./logo";

const AvatarUploadStep = ({ user }) => {
  const dispatch = useDispatch();
  const { cookieBannerIsShowing } = useSelector(LoginStore.selectors.select());
  const cookieBannerHeight = 72;
  const footerHeight = 80;

  if (!user) return null;

  return (
    <div
      className="flex"
      style={{
        height: cookieBannerIsShowing ? `calc(100vh - ${cookieBannerHeight}px` : "100vh",
        width: "100%",
      }}
    >
      <Logo className="absolute m10" />
      <AvatarUpload
        secondaryButtonLabel="Skip"
        handleSecondaryButtonClick={handlePhotoUploadSkip}
        handleUploadSuccess={() => redirectUser()}
        user={user}
        styles={{
          height: `calc(100vh - ${
            cookieBannerIsShowing ? cookieBannerHeight + footerHeight : footerHeight
          }px)`,
        }}
      />
    </div>
  );

  async function handlePhotoUploadSkip() {
    await dispatch(updateOnboarding({ skip_avatar_upload: true }));
    redirectUser();
  }
};

export { AvatarUploadStep };
